/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountNav,
  BodyGetYearlyEndingNav,
  BrokerAccountRestriction,
  Filter,
  HTTPValidationError,
  HistoricalStatistics,
  PortfolioCacheRefreshEvidence,
  PortfolioPage,
  YearlyEndingNav,
} from '../models/index';
import {
    AccountNavFromJSON,
    AccountNavToJSON,
    BodyGetYearlyEndingNavFromJSON,
    BodyGetYearlyEndingNavToJSON,
    BrokerAccountRestrictionFromJSON,
    BrokerAccountRestrictionToJSON,
    FilterFromJSON,
    FilterToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    HistoricalStatisticsFromJSON,
    HistoricalStatisticsToJSON,
    PortfolioCacheRefreshEvidenceFromJSON,
    PortfolioCacheRefreshEvidenceToJSON,
    PortfolioPageFromJSON,
    PortfolioPageToJSON,
    YearlyEndingNavFromJSON,
    YearlyEndingNavToJSON,
} from '../models/index';

export interface CalculatePreTradePortfoliosRequest {
    dataAsOfDate: string;
    tradeDate: string;
}

export interface GetBrokerAccountRestrictionsRequest {
    requestBody: Array<string>;
}

export interface GetNavsRequest {
    requestBody?: Array<string>;
}

export interface GetPreTradePortfolioRequest {
    pageIndex?: number;
    pageSize?: number;
    sortLabel?: string;
    sortDesc?: boolean;
    filter?: Array<Filter>;
}

export interface GetReportPortfolioRequest {
    pageIndex?: number;
    pageSize?: number;
    sortLabel?: string;
    sortDesc?: boolean;
    filter?: Array<Filter>;
}

export interface GetYearlyEndingNavRequest {
    bodyGetYearlyEndingNav: BodyGetYearlyEndingNav;
}

export interface InvalidatePortfolioCacheRequest {
    expectedAsOfDate?: string;
}

/**
 * 
 */
export class PortfolioApi extends runtime.BaseAPI {

    /**
     * Calculate pre trade portfolios.
     */
    async calculatePreTradePortfoliosRaw(requestParameters: CalculatePreTradePortfoliosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.dataAsOfDate === null || requestParameters.dataAsOfDate === undefined) {
            throw new runtime.RequiredError('dataAsOfDate','Required parameter requestParameters.dataAsOfDate was null or undefined when calling calculatePreTradePortfolios.');
        }

        if (requestParameters.tradeDate === null || requestParameters.tradeDate === undefined) {
            throw new runtime.RequiredError('tradeDate','Required parameter requestParameters.tradeDate was null or undefined when calling calculatePreTradePortfolios.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/reports/pre-trade/data-as-of-date/{data_as_of_date}/trade-date/{trade_date}`.replace(`{${"data_as_of_date"}}`, encodeURIComponent(String(requestParameters.dataAsOfDate))).replace(`{${"trade_date"}}`, encodeURIComponent(String(requestParameters.tradeDate))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Calculate pre trade portfolios.
     */
    async calculatePreTradePortfolios(requestParameters: CalculatePreTradePortfoliosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.calculatePreTradePortfoliosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve broker-reported account restrictions (latest nav report) for the given portfolios.
     */
    async getBrokerAccountRestrictionsRaw(requestParameters: GetBrokerAccountRestrictionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BrokerAccountRestriction>>> {
        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling getBrokerAccountRestrictions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/broker-account-restrictions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BrokerAccountRestrictionFromJSON));
    }

    /**
     * Retrieve broker-reported account restrictions (latest nav report) for the given portfolios.
     */
    async getBrokerAccountRestrictions(requestParameters: GetBrokerAccountRestrictionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BrokerAccountRestriction>> {
        const response = await this.getBrokerAccountRestrictionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get historical AUM and portfolio count statistics
     */
    async getHistoricalStatisticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HistoricalStatistics>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/historical-statistics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HistoricalStatisticsFromJSON));
    }

    /**
     * Get historical AUM and portfolio count statistics
     */
    async getHistoricalStatistics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HistoricalStatistics>> {
        const response = await this.getHistoricalStatisticsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve NAV values for accounts.
     */
    async getNavsRaw(requestParameters: GetNavsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccountNav>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/nav`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccountNavFromJSON));
    }

    /**
     * Retrieve NAV values for accounts.
     */
    async getNavs(requestParameters: GetNavsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccountNav>> {
        const response = await this.getNavsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve pre-trade portfolios with the specified filters.
     */
    async getPreTradePortfolioRaw(requestParameters: GetPreTradePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioPage>> {
        const queryParameters: any = {};

        if (requestParameters.pageIndex !== undefined) {
            queryParameters['page_index'] = requestParameters.pageIndex;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.sortLabel !== undefined) {
            queryParameters['sort_label'] = requestParameters.sortLabel;
        }

        if (requestParameters.sortDesc !== undefined) {
            queryParameters['sort_desc'] = requestParameters.sortDesc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/pre-trade-portfolio`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.filter?.map(FilterToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioPageFromJSON(jsonValue));
    }

    /**
     * Retrieve pre-trade portfolios with the specified filters.
     */
    async getPreTradePortfolio(requestParameters: GetPreTradePortfolioRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioPage> {
        const response = await this.getPreTradePortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve portfolios from the Data Warehouse (T-1 data) with the specified filters.
     */
    async getReportPortfolioRaw(requestParameters: GetReportPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioPage>> {
        const queryParameters: any = {};

        if (requestParameters.pageIndex !== undefined) {
            queryParameters['page_index'] = requestParameters.pageIndex;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.sortLabel !== undefined) {
            queryParameters['sort_label'] = requestParameters.sortLabel;
        }

        if (requestParameters.sortDesc !== undefined) {
            queryParameters['sort_desc'] = requestParameters.sortDesc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/report-portfolio`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.filter?.map(FilterToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioPageFromJSON(jsonValue));
    }

    /**
     * Retrieve portfolios from the Data Warehouse (T-1 data) with the specified filters.
     */
    async getReportPortfolio(requestParameters: GetReportPortfolioRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioPage> {
        const response = await this.getReportPortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Broker account ids should be concatenation of broker id and a_c (using _), e.g SCHWAB_12345678
     * Retrieve ending NAV values for the previous 2 years for the given accounts.
     */
    async getYearlyEndingNavRaw(requestParameters: GetYearlyEndingNavRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<YearlyEndingNav>>> {
        if (requestParameters.bodyGetYearlyEndingNav === null || requestParameters.bodyGetYearlyEndingNav === undefined) {
            throw new runtime.RequiredError('bodyGetYearlyEndingNav','Required parameter requestParameters.bodyGetYearlyEndingNav was null or undefined when calling getYearlyEndingNav.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/year-end-nav`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BodyGetYearlyEndingNavToJSON(requestParameters.bodyGetYearlyEndingNav),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(YearlyEndingNavFromJSON));
    }

    /**
     * Broker account ids should be concatenation of broker id and a_c (using _), e.g SCHWAB_12345678
     * Retrieve ending NAV values for the previous 2 years for the given accounts.
     */
    async getYearlyEndingNav(requestParameters: GetYearlyEndingNavRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<YearlyEndingNav>> {
        const response = await this.getYearlyEndingNavRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invalidate and update positions and portfolios cache
     */
    async invalidatePortfolioCacheRaw(requestParameters: InvalidatePortfolioCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioCacheRefreshEvidence>> {
        const queryParameters: any = {};

        if (requestParameters.expectedAsOfDate !== undefined) {
            queryParameters['expected_as_of_date'] = requestParameters.expectedAsOfDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/portfolio-cache`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioCacheRefreshEvidenceFromJSON(jsonValue));
    }

    /**
     * Invalidate and update positions and portfolios cache
     */
    async invalidatePortfolioCache(requestParameters: InvalidatePortfolioCacheRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioCacheRefreshEvidence> {
        const response = await this.invalidatePortfolioCacheRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
